import { render } from "./AdminSideBar.vue?vue&type=template&id=5067bb02"
import script from "./AdminSideBar.vue?vue&type=script&lang=js"
export * from "./AdminSideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__